/**
 * ZoneAlarm Style02 - Stitch v2: gold theme + card + 光暈光點
 */
import type { TraitControlProps } from './types'
import { getTraitConfig } from './traitStyleConfig'
import './ZoneAlarmStyle02.css'

export function ZoneAlarmStyle02({ device, state }: TraitControlProps) {
  const { icon } = getTraitConfig('ZoneAlarm')
  const deviceName = (device?.nickname && String(device.nickname).trim()) || 'Zone Alarm'
  const armed = (state?.armed ?? state?.alarmState ?? state?.status) as boolean | string | undefined
  const isArmed = armed === true || armed === 'ARMED' || armed === 'armed' || String(armed).toLowerCase() === 'true'
  const stateToken = isArmed ? 'on armed' : 'off disarmed'

  return (
    <div
      className="trait-zonealarm-style02 trait-stitch-v2-glass"
      data-css-slot="alarmSurface"
      data-css-slot-label="Alarm Surface"
      data-css-state={stateToken}
    >
      <div className="trait-zonealarm-style02__content">
        <span
          className="trait-zonealarm-style02__name"
          data-css-slot="alarmName"
          data-css-slot-label="Alarm Name"
          data-css-state={stateToken}
        >
          {deviceName}
        </span>
        <span
          className={`trait-zonealarm-style02__status ${isArmed ? 'armed' : ''}`}
          data-css-slot="alarmStatus"
          data-css-slot-label="Alarm Status"
          data-css-state={stateToken}
        >
          {isArmed ? 'ARMED' : 'DISARMED'}
        </span>
      </div>
      <div className="trait-zonealarm-style02__indicator">
        <span
          className={`material-symbols-outlined trait-zonealarm-style02__icon ${isArmed ? 'armed' : ''}`}
          aria-hidden
          data-css-slot="alarmIcon"
          data-css-slot-label="Alarm Icon"
          data-css-state={stateToken}
        >
          {icon}
        </span>
      </div>
    </div>
  )
}
